module.exports = __webpack_public_path__ + "7e8f22d0e865aaf6ed71133aad5f7fdc.MP3";